<template>
    <div class="c-date-goto-month">
      <template v-if="isDesktopDevice">
        <ul class="c-date-goto-month__months" v-dragscroll @dragscrollstart="addDraggingClass" @dragscrollend="removeDraggingClass">
          <li v-for="month in availableMonths"><button @click="chosenMonth(month.value)">{{ month.label }}</button></li>
        </ul>
      </template>
      <template v-else>
        <ul class="c-date-goto-month__months">
          <li v-for="month in availableMonths"><button @click="chosenMonth(month.value)">{{ month.label }}</button></li>
        </ul>
      </template>


    </div>
</template>

<script>

    import {EventBus} from "../event-bus"

    export default {
        name: "GotoMonth",
        props: ['availableMonths'],
        data() {
            return {
                selected: null,
                options: [],
                isDesktopDevice: true,
            }
        },
        beforeMount() {
          if ("ontouchstart" in document.documentElement) {
            this.isDesktopDevice = false
          }
        },
        mounted() {
            this.selected = this.selectedMonth
        },
        methods: {
            chosenMonth(month) {
                EventBus.$emit('updateDatePicker', month)
                EventBus.$emit('goToMonth', month)
            },
          addDraggingClass(e) {
            document.querySelector('.c-date-goto-month__months').classList.add('dragging')
          },
          removeDraggingClass() {
            document.querySelector('.c-date-goto-month__months').classList.remove('dragging')
          },
        }
    }
</script>

<style lang="scss" scoped>

</style>
